import { event, GtagEvent } from "./event";

/**
 * 
 */
export interface UnlockAchievement extends GtagEvent {
    achievement_id:string;
}
export const unlock_achievement = ($_:UnlockAchievement) => event('unlock_achievement',$_);